import { PAUserDetailWithKey } from '../hooks/useSharePointData';
import {
  Suggestion,
  TagOption,
  User,
} from '../components/container/forms/types';

export const convertToTagOptions = (
  users: PAUserDetailWithKey[]
): (TagOption & { key: string })[] => {
  return users.map((user) => ({
    label: user.value[0]?.displayName || '',
    value: user.value[0]?.userPrincipalName || '',
    key: user.key,
    email: user.value[0]?.userPrincipalName || '',
  }));
};

export const mapUsersToSuggestions = (users: User[]): Suggestion[] => {
  return users.map((user) => ({
    label: user.displayName,
    value: user.mail,
    email: user.userPrincipalName,
  }));
};
